<template>
  <f7-page>
    <f7-navbar title="餐點排行進階查詢" back-link="back"></f7-navbar>
    <f7-list no-hairlines-md>
      <f7-list-item>
        <f7-label>查詢範圍</f7-label>
        <f7-input type="text" placeholder="選擇日期" readonly="readonly" input-id="demo-calendar-modal" :value="value" clear-button />
      </f7-list-item>
      <f7-list-item title="報表單位" group-title />
      <f7-list-item radio title="日" value="day" name="unit" :checked="searchUnit === 'day'" @change="setSearchUnit($event.target.value)" />
      <f7-list-item radio title="週" value="week" name="unit" :checked="searchUnit === 'week'" @change="setSearchUnit($event.target.value)" />
      <f7-list-item radio title="月" value="month" name="unit" :checked="searchUnit === 'month'" @change="setSearchUnit($event.target.value)" />
      <f7-list-item radio title="年" value="year" name="unit" :checked="searchUnit === 'year'" @change="setSearchUnit($event.target.value)" />
      <f7-button raised fill style="margin: 20px;" :style="{ background: startDate && endDate ? '#4CAF50' : '#888888' }" @click="search">查詢</f7-button>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  dependencies: ['themeColor'],
  mounted () {
    const that = this
    const today = moment().format('YYYY-MM-DD')
    this.setSearchRange({ startDate: today, endDate: today })
    this.$f7.calendar.create({
      inputEl: '#demo-calendar-modal',
      openIn: 'customModal',
      rangePicker: true,
      header: true,
      footer: true,
      dateFormat: 'yyyy-mm-dd',
      dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
      monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      on: {
        change (c, [startDate, endDate]) {
          if (endDate) {
            that.setSearchRange({
              startDate: moment(new Date(startDate).toISOString()).format('YYYY-MM-DD'),
              endDate: moment(new Date(endDate).toISOString()).format('YYYY-MM-DD')
            })
          }
        }
      }
    })
  },
  computed: {
    ...mapState('statisticsModule', ['searchUnit', 'startDate', 'endDate', 'searchUnit', 'storeHotSaleReport']),
    ...mapGetters(['storeId']),
    value () {
      return this.startDate + ' - ' + this.endDate
    }
  },
  methods: {
    ...mapActions('statisticsModule', ['getCustomStatistics', 'setSearchUnit', 'setSearchRange', 'getStoreHotSale', 'getStoreHotSaleReportData', 'clearStoreHotSaleReportData']),
    search () {
      this.clearStoreHotSaleReportData() // 清除掉上次的排行資料
      let index = 1 // 排序用的 index
      let startDateMoment = moment(this.startDate)
      let endDateMoment = moment(this.endDate)
      switch (this.searchUnit) {
        case 'day':
          while (!startDateMoment.isAfter(endDateMoment)) {
            this.getStoreHotSaleReportData({ startDateString: startDateMoment.format('YYYY-MM-DD'), endDateString: startDateMoment.format('YYYY-MM-DD'), index })
            startDateMoment.add(1, 'day')
            index++
          }
          break
        case 'week':
          while (!startDateMoment.isAfter(endDateMoment) && !startDateMoment.isSame(endDateMoment)) {
            this.getStoreHotSaleReportData({ startDateString: startDateMoment.format('YYYY-MM-DD'), endDateString: startDateMoment.add(6, 'day').format('YYYY-MM-DD'), index })
            startDateMoment.add(1, 'day')
            index++
          }
          break
        case 'month':
          while (!startDateMoment.isAfter(endDateMoment)) {
            if (startDateMoment.clone().endOf('month').isAfter(endDateMoment)) {
              this.getStoreHotSaleReportData({ startDateString: startDateMoment.format('YYYY-MM-DD'), endDateString: endDateMoment.format('YYYY-MM-DD'), index })
            } else {
              this.getStoreHotSaleReportData({ startDateString: startDateMoment.format('YYYY-MM-DD'), endDateString: startDateMoment.clone().endOf('month').format('YYYY-MM-DD'), index })
            }
            startDateMoment.add(1, 'month').startOf('month')
            index++
          }
          break
        case 'year':
          while (!startDateMoment.isAfter(endDateMoment)) {
            if (startDateMoment.clone().endOf('year').isAfter(endDateMoment)) {
              this.getStoreHotSaleReportData({ startDateString: startDateMoment.format('YYYY-MM-DD'), endDateString: endDateMoment.format('YYYY-MM-DD'), index })
            } else {
              this.getStoreHotSaleReportData({ startDateString: startDateMoment.format('YYYY-MM-DD'), endDateString: startDateMoment.clone().endOf('year').format('YYYY-MM-DD'), index })
            }
            startDateMoment.add(1, 'year').startOf('year')
            index++
          }
          break
        default:
          break
      }
      this.$f7router.navigate(`/stores/${this.storeId}/hot-sale-search-results`)
    }
  }
}
</script>
